import { logUsage } from 'owa-analytics';
import { lazyBootstrapYammer } from 'owa-yammer-bootstrap';
import { lazyOpenYammerPublisher } from 'owa-yammer-publisher';

export default function initializeYammerPublisher(): void {
    // Prefetch and bootstrap yammer
    lazyBootstrapYammer.import().then(bootstrapYammer => bootstrapYammer());

    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logUsage('YammerPublisher_PrefetchHit', undefined);

    // Prefetch main dialog code
    lazyOpenYammerPublisher.import();
}
